export enum LabelSize { // width x height
    _4x6 = '4x6',
    _1x1 = '1x1',
}